// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HKbA","fullView":"styles_fullView__33gpH"};